import { useRouter } from '../contexts/RouterContext';
import { useSpecialistContext } from '../contexts/SpecialistContext';
import { fetchSpecialistById, fetchSpecialists } from '../modules/specialists';

export const useOpenSpecialist = () => {
  const { setSelectedSpecialist } = useSpecialistContext();

  const { resetRoutes, goTo } = useRouter();

  async function findSpecialistByName(name: string) {
    const response = await fetchSpecialists({ name: name.replaceAll('-', ' ') });
    if (response.data.length) return response.data[0].id;
  }

  async function findSpecialistById(id: string) {
    const response = await fetchSpecialistById(id);

    if (response.data) return response.data;
  }

  async function openSpecialist(name: string) {
    try {
      const specialistId = await findSpecialistByName(name);

      if (specialistId) {
        const specialistDetails = await findSpecialistById(specialistId);

        setSelectedSpecialist(specialistDetails);
      } else {
        resetRoutes();
        goTo(1);
      }
    } catch (error) {
      console.error('🚀 ~ file: useOpenSpecialist.ts:31 ~ openSpecialist ~ error:', error);
    }
  }
  return { openSpecialist };
};
